import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { callFetchPodcast } from "../../config/api";

interface IState {
  isFetching: boolean;
  meta: {
    current: any;
    pageSize: any;
    pages: any;
    total: any;
  };
  result: any;
}

// first, create thunk
export const fetchPodcast = createAsyncThunk(
  "podcast/fetchPodcast",
  async ({ query }: { query: string }) => {
    const response = await callFetchPodcast(query);
    return response;
  }
);

const initialState: IState = {
  isFetching: true,
  meta: {
    current: 1,
    pageSize: 10,
    pages: 0,
    total: 0,
  },
  result: [],
};

export const podcastSlice = createSlice({
  name: "podcast",
  initialState,
  reducers: {
    setActiveMenu: (state, action) => {},
  },

  extraReducers: (builder) => {
    builder.addCase(fetchPodcast.pending, (state, action) => {
      state.isFetching = true;
    });
    builder.addCase(fetchPodcast.rejected, (state, action) => {
      state.isFetching = false;
    });
    builder.addCase(fetchPodcast.fulfilled, (state, action: any) => {
      if (action.payload && action.payload.data) {
        state.isFetching = false;
        state.meta = action.payload.data.meta;
        state.result = action.payload.data.result;
      }
    });
  },
});

export const { setActiveMenu } = podcastSlice.actions;

export default podcastSlice.reducer;
